<ng-container *ngIf="formaPagamentoSalvaCartao() && pagamentoCartaoPreenchido()">
  <div class="mt-2" *ngIf=" statusStrongAuthCartao?.sugerirLogin">
    <div class="login-suggestion" (click)="fazerLogin()">
      <div class="icon-container">
        <i class="fa fa-credit-card"></i>
      </div>
      <div class="text-container">
        <span class="title">Quer mais rapidez e comodidade?</span>
        <span class="subtitle">Indetifique-se para reutilizar um cartão ou para salvar seu cartão para uma próxima compra</span>
      </div>
      <div class="action-icon">
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>

  <div class="mt-2" *ngIf="statusStrongAuthCartao?.sugerirCadastro   ">
    <div class="login-suggestion" (click)="fazerCadastro()">
      <div class="icon-container">
        <i class="fa fa-credit-card"></i>
      </div>
      <div class="text-container">
        <span class="title">Quer mais rapidez e comodidade?</span>
        <span class="subtitle">Faça um cadastro seguro para reutilizar um cartão  para uma próxima compra</span>
      </div>
      <div class="action-icon">
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>
</ng-container>


<div class="mt-2" *ngIf="deveExibirConfigCartaoSalvo()">
  <div class="custom-control custom-switch">
    <input type="checkbox" class="custom-control-input" id="salvarCartaoCheckout"
           name="salvarCartaoCheckout" [(ngModel)]="salvarCartaoProximasCompras"
           (ngModelChange)="alterouSalvarCartaoProximasCompras()">
    <label class="custom-control-label" for="salvarCartaoCheckout">
      Utilizar cartão nas próximas compras
    </label>
  </div>

  <small class="text-danger d-block mt-2" *ngIf="erroSalvarCartao">{{erroSalvarCartao}}</small>


  <div class="mt-2" *ngIf="statusStrongAuthCartao && !statusStrongAuthCartao.autenticacaoForteValida && !statusStrongAuthCartao.sugerirLogin">
    <div class="modal" tabindex="-1" role="dialog"  *ngIf="exibirPopupAutenticacao">
      <div class="modal-dialog" role="document" style="">
        <div class="modal-content modal-clean">
          <div class="modal-body text-center p-4">
            <h5 class="modal-title font-weight-bold mb-2">Autentique sua conta</h5>
            <ng-container *ngIf="!codigoEnviado">
              <p class=" mb-4">
                Para sua segurança enviaremos um código para confirmar e validar acesso seu cartão<br>
                <strong>{{obtenhaEmailMascarado()}}</strong>
              </p>

              <button class="btn btn-dark btn-block btn-lg mb-3"
                      [disabled]="processandoStrongAuthCartao"
                      (click)="soliciteCodigoStrongAuthCartao()">
                Enviar código
              </button>

              <button class="btn btn-link text-dark font-weight-bold" (click)="fecharPopup()">
                Voltar
              </button>
            </ng-container>

            <ng-container *ngIf="codigoEnviado">
              <h5 class="modal-title font-weight-bold mb-2">Digite o Código</h5>
              <p class="text-muted mb-4">
                Digite o código de 6 dígitos que enviamos para:<br>
                <strong>{{obtenhaEmailMascarado()}}</strong>
              </p>

              <div class="code-inputs mb-4">
                <input *ngFor="let digit of inputsCodigo; let i = index"
                       type="tel"
                       class="form-control code-box text-center"
                       [id]="'digit-' + i"
                       [value]="digit"
                       maxlength="1"
                       (keyup)="onDigitInput($event, i)"
                       (paste)="onPaste($event)"
                       [disabled]="processandoStrongAuthCartao">
              </div>

              <div class="mb-4" *ngIf="tempoReenviar <= 0">
                <button class="btn btn-link text-muted p-0"
                        [disabled]="processandoStrongAuthCartao"
                        (click)="soliciteCodigoStrongAuthCartao()">
                  Reenviar código
                </button>
              </div>
              <div class="mb-4 text-muted" *ngIf="tempoReenviar > 0">
                Reenviar código em {{tempoReenviar | number:'2.0-0'}}s
              </div>

              <button class="btn btn-dark btn-block btn-lg mb-3"
                      [disabled]="processandoStrongAuthCartao || codigoStrongAuthCartao.length < 6"
                      (click)="valideCodigoStrongAuthCartao()">
                Continuar
              </button>

              <button class="btn btn-link text-dark font-weight-bold" (click)="fecharPopup()">
                Voltar
              </button>
            </ng-container>

            <small class="text-danger d-block mt-2" *ngIf="erroSalvarCartao">{{erroSalvarCartao}}</small>
            <small class="text-success d-block mt-2" *ngIf="mensagemCartaoSalvo">{{mensagemCartaoSalvo}}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
